// eslint-disable-next-line no-control-regex, no-useless-escape
export const EMAIL_REGEX = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
export const DIGITS_REGEX = /^\d+$/;
export const DIGITS_INCLUDE_NEGATIVE_REGEX = /^-?\d+$/;
export const DECIMAL_REGEX = /^\d+\.?\d{0,2}$/;
export const LETTERS_REGEX = /^[A-Za-z]+$/;
export const CONTAINS_LOWERCASE_LETTER_REGEX = /[a-z]+/;
export const CONTAINS_UPPERCASE_LETTER_REGEX = /[A-Z]+/;
export const CONTAINS_DIGIT_REGEX = /[\d]+/;
export const CONTAINS_SYMBOL_REGEX = /[~!@#$%^&*()_+{}|:<>?/.,;'=-]+/;
export const SPACES_ONLY_REGEX = /^\s+$/u;
// eslint-disable-next-line no-control-regex
export const USERNAME_REGEX = /^[\w\d!#$%&'*+\-/=?^_`{|}~.@]+$/ui;
export const PHONE_NUMBER_REGEX = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,14}$/;

export function isEmpty(value) {
    return (
        value === undefined ||
        value === null ||
        value === '' ||
        (typeof value === 'string' && value.trim() === '')
    );
}

export function getFirstError(rules) {
    return (value, allValues) =>
        rules.map(rule => rule(value, allValues)).filter(error => !!error)[0];
}

export function getValidationErrors(values, rules) {
    const errors = {};

    Object.keys(rules).forEach((key) => {
        if (
            typeof rules[key] === 'function' ||
            (typeof rules[key] === 'object' && Array.isArray(rules[key]))
        ) {
            const validate = getFirstError([].concat(rules[key]));

            if (Object.prototype.hasOwnProperty.call(values, key)) {
                const error = validate(values[key], values);

                if (error) {
                    errors[key] = error;
                }
            }
        }
    });

    return errors;
}

export function createValidator(rules) {
    return (values = {}) => getValidationErrors(values, rules);
}

// RULES

export function email(message = 'Invalid format') {
    return (value) => {
        if (!isEmpty(value) && !EMAIL_REGEX.test(value)) {
            return message;
        }

        return null;
    };
}

export function phoneNumber(message = 'Invalid phone Number') {
    return (value) => {
        if (!isEmpty(value) && !PHONE_NUMBER_REGEX.test(value)) {
            return message;
        }

        return null;
    };
}

export function minLength(min, message = `Min ${min} characters`) {
    return (value) => {
        if (!isEmpty(value) && value.length < min) {
            return message;
        }

        return null;
    };
}

export function maxLength(max, message = `Max ${max} characters`) {
    return (value) => {
        if (!isEmpty(value) && value.length > max) {
            return message;
        }

        return null;
    };
}

export function required(message = 'Required') {
    return (value) => {
        if (isEmpty(value)) {
            return message;
        }

        return null;
    };
}

export function digits(message = 'Digits only') {
    return (value) => {
        if (!isEmpty(value) && !DIGITS_REGEX.test(value)) {
            return message;
        }
        return null;
    };
}

export function digitsIncludeNegative(message = 'Digits only') {
    return (value) => {
        if (!isEmpty(value) && !DIGITS_INCLUDE_NEGATIVE_REGEX.test(value)) {
            return message;
        }
        return null;
    };
}

export function decimal(message = 'Decimal format XXX.XX') {
    return (value) => {
        if (!isEmpty(value) && !DECIMAL_REGEX.test(value)) {
            return message;
        }
        return null;
    };
}

export function onlyLetters(message = 'Only letters') {
    return (value) => {
        if (!isEmpty(value) && !LETTERS_REGEX.test(value)) {
            return message;
        }

        return null;
    };
}

export function noSpacesFill(message = 'No spaces') {
    return (value) => {
        if (typeof value === 'string' && SPACES_ONLY_REGEX.test(value)) {
            return message;
        }

        return null;
    };
}

export function username(message = 'Invalid format') {
    return (value) => {
        if (!isEmpty(value) && !USERNAME_REGEX.test(value)) {
            return message;
        }

        return null;
    };
}

export function containsLowerCase(message = 'Must contain at least one lowercase letter') {
    return (value) => {
        if (!isEmpty(value) && !CONTAINS_LOWERCASE_LETTER_REGEX.test(value)) {
            return message;
        }
        return null;
    };
}

export function containsUpperCase(message = 'Must contain at least one uppercase letter') {
    return (value) => {
        if (!isEmpty(value) && !CONTAINS_UPPERCASE_LETTER_REGEX.test(value)) {
            return message;
        }
        return null;
    };
}

export function containsDigit(message = 'Must contain at least one digit') {
    return (value) => {
        if (!isEmpty(value) && !CONTAINS_DIGIT_REGEX.test(value)) {
            return message;
        }
        return null;
    };
}

export function containsSymbol(message = 'Must contain at least one symbol') {
    return (value) => {
        if (!isEmpty(value) && !CONTAINS_SYMBOL_REGEX.test(value)) {
            return message;
        }
        return null;
    };
}

export function mustBeDifferent(otherAttr, message = 'Must be different') {
    return (value, allValues) => {
        if (!isEmpty(value) && value === allValues[otherAttr]) {
            return message;
        }
        return null;
    };
}

export function mustBeSame(otherAttr, message = 'Do not match') {
    return (value, allValues) => {
        if (!isEmpty(value) && value !== allValues[otherAttr]) {
            return message;
        }
        return null;
    };
}

export function isGreaterThanX(x, message = 'Must be greater than ') {
    return (value) => {
        // eslint-disable-next-line eqeqeq
        if (!isEmpty(value) && value < x && value !== -1) {
            return message + x;
        }
        return null;
    };
}
